import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormButtonsComponent } from 'components/form-buttons/form-buttons.component';
import { ModalComponent } from 'components/modal/modal.component';
import { Modal, ModalActionType } from 'components/modal/modal.model';

@Component({
    selector: 'app-delete-current-user-modal',
    templateUrl: './delete-current-user-modal.component.html',
    styleUrls: ['./delete-current-user-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        FormButtonsComponent,
        ModalComponent,
    ],
})
export class DeleteCurrentUserModalComponent implements OnChanges {
    @Input() open = false;
    @Output() closed = new EventEmitter<ModalActionType>();

    deleteCurrentUserModal: Modal;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.open?.currentValue) {
            this.modalOpen();
        } else {
            this.modalClose();
        }
    }

    modalOpen() {
        this.deleteCurrentUserModal = {
            isOpen: true,
            actions: {},
            header: {
                textKey: 'table.delete-self-warning.title',
                showSeparator: true,
                textAlignment: 'left',
            },
            fullScreen: false,
            content: true,
            width: 600,
        };
    }

    ok() {
        this.closed.next(ModalActionType.ok);
    }

    handleModalClose(action: ModalActionType) {
        this.closed.next(action);
    }

    modalClose() {
        this.deleteCurrentUserModal = null;
        this.closed.emit();
    }
}
